import { Injectable, inject } from '@angular/core';
import { EnglishLanguage, HttpService, UrlService } from '@boels/helpers';
import { Country, TitleList } from '@boels/models';
import { Observable, combineLatest, switchMap } from 'rxjs';
import { CultureFacade } from '../../cultures/facade/cultures.facade';
import { SiteContextFacade } from '../../site-context/facade/site-context.facade';

@Injectable({
  providedIn: 'any',
})
export class UserProfileGatewayService {
  private readonly httpService = inject(HttpService);
  private urlService = inject(UrlService);
  private siteContextFacade = inject(SiteContextFacade);
  private cultureFacade = inject(CultureFacade);

  getTitles(): Observable<TitleList> {
    return combineLatest([
      this.siteContextFacade.getActiveBaseSiteEntity(),
      this.cultureFacade.getActiveLanguage(),
      this.cultureFacade.getActiveCurrency(),
    ]).pipe(
      switchMap(([activeBaseSite, lang, currency]) => {
        const params = [
          ['lang', lang],
          ['curr', currency],
        ];

        const url = this.urlService.combineUri(activeBaseSite.uid, 'titles');

        return this.httpService.get<TitleList>(url, params);
      }),
    );
  }

  getCountries(overrideParams?: boolean): Observable<{ countries: Country[] }> {
    return combineLatest([
      this.siteContextFacade.getActiveBaseSiteEntity(),
      this.cultureFacade.getActiveLanguage(),
      this.cultureFacade.getActiveCurrency(),
    ]).pipe(
      switchMap(([activeBaseSite, lang, currency]) => {
        const params = [
          [
            'lang',
            overrideParams && lang !== 'en_GB'
              ? EnglishLanguage.ENGLISH.concat(
                  '_',
                  activeBaseSite.country?.isocode || 'NL',
                )
              : lang,
          ],
          ['curr', currency],
        ];
        if (!overrideParams) {
          params.push(['type', 'BILLING']);
        }
        const url = this.urlService.combineUri(activeBaseSite.uid, 'countries');

        return this.httpService.get<{ countries: Country[] }>(url, params);
      }),
    );
  }
}
